import React from 'react'

export default class SettingsPage extends React.Component {
  render() {
    return <div>hello</div>
  }
}
